<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <div class="box-title-container mb-1">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div class="icon-container">
            <ion-icon name="pricetag"></ion-icon>
          </div>
          <div>
            <p class="title">Cost & Pricing</p>
          </div>
        </div>
        <div class="input-container d-flex align-items-center gap-1" *ngIf="serviceBasedSections.showTourPackage || serviceBasedSections.showRouteCraft">
          <div class="">
            <label class="label">Currency</label>
          </div>
          <select class="input py-1 border-1" (change)="onCurrencyChange($event)">
            <option *ngFor="let item of currencyLov" [selected]="selectedCurrency === item.key" [value]="item.key">{{item.name}}</option>
          </select>
        </div>
      </div>
    </div>

    <form [formGroup]="landPackageForm" 
      *ngIf="serviceBasedSections.showTourPackage || serviceBasedSections.showRouteCraft">
      

      <ng-container formArrayName="landPackages" >
        <div *ngFor="let package of landPackages.controls; let i = index" [formGroupName]="i" class="ion-padding-horizontal">

          <div class="ion-no-padding d-flex justify-content-between">
            <ion-title class="dark-title-sm ion-no-padding land-package-title">Land Package {{i+1}}</ion-title>
            <div>
              <button type="button" class="add-more-btn" (click)="removeLandPackage(i)" *ngIf="i !== 0">x Remove</button>
            </div>
          </div>
          <div class="row" *ngIf="serviceBasedSections.showHotels">
            <div class="col-6">
              <div class="input-container">
                <label for="" class="label">Hotels Included* <span class="warning-message" *ngIf="package.get('hotelsIncluded')?.errors?.['missingHotels'] && package.get('hotelsIncluded')?.touched">Select atleast one hotel from each location</span></label>
                <div [ngClass]="{ 'invalid-input': package.get('hotelsIncluded')?.invalid && package.get('hotelsIncluded')?.touched }">
                  <app-hotels-selection-input [groupedHotels]="getHotelsData()" formControlName="hotelsIncluded"></app-hotels-selection-input>
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="!package.get('addPriceDetailsBreakdown')?.value">
            <div class="row">
              <div class="col-3">
                <div class="input-container">
                  <label for="" class="label">Cost / Adult*</label>
                  <div
                    [ngClass]="{ 'invalid-input': package.get('perAdult')?.invalid && package.get('perAdult')?.touched }">
                    <app-cost-pricing-input [prefix]="selectedCurrency" formControlName="perAdult" [disableDrowdown]="true" [dropdownArray]="noOfAdutlsDropdown"></app-cost-pricing-input>
                    <div *ngIf="dmcPackageId && package.get('dmcAdultCost')?.value">
                      <p class="dmc-price">DMC cost - {{package.get('dmcAdultCost')?.value}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="input-container">
                  <label for="" class="label">Cost / child with bed</label>
                  <div
                    [ngClass]="{ 'invalid-input': package.get('perChildWithBed')?.invalid && package.get('perChildWithBed')?.touched }">
                    <app-cost-pricing-input [prefix]="selectedCurrency" formControlName="perChildWithBed" [dropdownArray]="noOfChildrenDropdown"></app-cost-pricing-input>
                    <div *ngIf="dmcPackageId && package.get('dmcChildWithBedCost')?.value">
                      <p class="dmc-price">DMC cost - {{package.get('dmcChildWithBedCost')?.value}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="input-container">
                  <label for="" class="label">Cost / child without bed</label>
                  <div
                    [ngClass]="{ 'invalid-input': package.get('perChildWithoutBed')?.invalid && package.get('perChildWithoutBed')?.touched }">
                    <app-cost-pricing-input [prefix]="selectedCurrency" formControlName="perChildWithoutBed" [dropdownArray]="noOfChildrenDropdown"></app-cost-pricing-input>
                    <div *ngIf="dmcPackageId && package.get('dmchildWithoutBedCost')?.value">
                      <p class="dmc-price">DMC cost - {{package.get('dmchildWithoutBedCost')?.value}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="input-container">
                  <label for="" class="label">Package Cost*</label>
                  <div
                    [ngClass]="{ 'invalid-input': package.get('packageCost')?.invalid && package.get('packageCost')?.touched }">
                    <app-select-text-input [prefix]="selectedCurrency" formControlName="packageCost"></app-select-text-input>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="row">
            <div class="col-12 mt-3">
              <div>
                <table class="table table-bordered invoice-items-table">
                  <thead>
                    <tr>
                      <td colspan="7" >
                        <div class="input-container p-2 table-title">
                          <div class="d-flex justify-content-between">
                            <div>
                              <ion-toggle class="cost-toggle-btn" formControlName="addPriceDetailsBreakdown" labelPlacement="end">Add Detailed Price Breakdown</ion-toggle>
                            </div>
                            <div>
                              <ion-toggle class="cost-toggle-btn" formControlName="showPriceDetail" labelPlacement="end">Show Detailed Breakdown in Quote</ion-toggle>
                            </div>
                          </div>                  
                        </div>
                      </td>
                    </tr>
                  </thead>
                  <ng-container *ngIf="package.get('addPriceDetailsBreakdown')?.value">
                    <thead>
                      <tr>
                        <th class="sm-column">S.no</th>
                        <th>Service*</th>
                        <th>
                          <div class="d-flex  flex-column">
                            <span>Cost/Adult*</span>
                            <select disabled [value]="getNoOfAdultsInPackage(i)">
                              <option *ngFor="let item of noOfAdutlsDropdown" [value]="item.value">{{item.name}}</option>
                            </select>
                          </div>
                        </th>
                        <th>
                          <div class="d-flex flex-column">
                            <span>Cost/Child With Bed</span>
                            <select (change)="setNoOfChildrenWithBedInPackage(i, $event)">
                              <option *ngFor="let item of noOfChildrenDropdown" [value]="item.value" [selected]="item.value === getNoOfChildrenWithBedInPackage(i)">{{item.name}}</option>
                            </select>
                          </div>
                        </th>
                        <th>
                          <div class="d-flex  flex-column">
                            <span>Cost/Child Without Bed</span>
                            <select (change)="setNoOfChildrenWithoutBedInPackage(i, $event)">
                              <option *ngFor="let item of noOfChildrenDropdown" [value]="item.value" [selected]="item.value === getNoOfChildrenWithoutBedInPackage(i)">{{item.name}}</option>
                            </select>
                          </div>
                        </th>
                        <th>Total</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody formArrayName="priceDetail">
                      <tr *ngFor="let price of getPriceDetailsArray(i).controls; index as priceIndex" [formGroupName]="priceIndex">
                        <td class="p-1 text-center">{{priceIndex+1}}</td>
                        <td [ngClass]="{ 'invalid-input': checkInvalidControl(price, 'type') }">
                          <input formControlName="type" class="table-input" [appMaxLength]="50">
                        </td>
                        <td [ngClass]="{ 'invalid-input': checkInvalidControl(price, 'costPerAdult') }">
                          <input formControlName="costPerAdult" appDecimalNumber class="table-input" [appMaxLength]="10">
                        </td>
                        <td [ngClass]="{ 'invalid-input': checkInvalidControl(price, 'costPerChildWithBed') }">
                          <input formControlName="costPerChildWithBed" appDecimalNumber class="table-input" [appMaxLength]="10">
                        </td>
                        <td [ngClass]="{ 'invalid-input': checkInvalidControl(price, 'costPerChildWithoutBed') }">
                          <input formControlName="costPerChildWithoutBed" appDecimalNumber class="table-input" [appMaxLength]="10">
                        </td>
                        <td [ngClass]="{ 'invalid-input': checkInvalidControl(price, 'totalCost') }">
                          <input formControlName="totalCost" class="table-input" readonly>
                        </td>
                        
                        <td>
                          <div class="table-actions">
                            <ion-button (click)="removePriceDetail(i, priceIndex)" [disabled]="getPriceDetailsArray(i).controls.length === 1" fill="clear" color="danger" class="action-btn"><ion-icon name="trash-outline"></ion-icon></ion-button>
                          </div>
                          
                        </td>
                      </tr>
                      <tr>
                        <td class="p-1"></td>
                        <td class="p-1">Total Per Person</td>
                        <td class="p-1">{{getTotalCostPerAdultInPackage(i)}}</td>
                        <td class="p-1">{{getTotalCostPerChildWithBedInPackage(i)}}</td>
                        <td class="p-1">{{getTotalCostPerChildWithoutBedInPackage(i)}}</td>
                        <td class="p-1">{{getPackageCost(i)}}</td>
                        <td class="p-1"></td>
                      </tr>
                      <tr>
                        <td colspan="7">
                            <div class="d-flex justify-content-end table-actions">
                              <ion-button (click)="addPriceDetail(i)" fill="clear" class="action-btn blue"><ion-icon name="add-outline"></ion-icon> Item</ion-button>
                            </div>
                        </td>
                      </tr>
                    </tbody>
                  </ng-container>
                </table>
                <div class="py-0">
                  <div class="input-container">
                    <p class="warning-message" *ngIf="checkPriceDetailsTotalCostMismatch(package)" style="font-size: 14px;">Total package cost should match with sum of total cost of price breakdown details</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="landPackages.length-1 === i ">
            <div class="col">
              <div class="d-flex justify-content-end align-items-end h-100">
                <button *ngIf="showAddMorePackageBtn" type="button" class="add-more-btn mb-1" (click)="addLandPackage()">+ Land Package</button>
              </div>
            </div>
          </div>

        <div class="dashed-line mt-1"></div>
        </div>
      </ng-container>

      <div class="ion-no-padding mb-1" *ngIf="showAirFares" >
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Airfare</ion-title>
      </div>

      <ng-container *ngIf="showAirFares" >
        <div class="ion-padding-horizontal">
          <div class="row">
            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Cost / Adult* ({{noOfAdults}} Adults)</label>
                <div
                  [ngClass]="{ 'invalid-input': landPackageForm.get('airfarePerAdult')?.invalid && landPackageForm.get('airfarePerAdult')?.touched }">
                  <app-select-text-input [prefix]="selectedCurrency" formControlName="airfarePerAdult"
                    [placeHolder]="'Enter airfare per adult'"></app-select-text-input>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Cost / Child* ({{childrenAboveTwo}} Children)</label>
                <div
                  [ngClass]="{ 'invalid-input': landPackageForm.get('airfarePerChild')?.invalid && landPackageForm.get('airfarePerChild')?.touched }">
                  <app-select-text-input [prefix]="selectedCurrency" formControlName="airfarePerChild"
                    [placeHolder]="'Enter airfare per child'"></app-select-text-input>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Cost / Infant* ({{childrenBelowTwo}} Infants)</label>
                <div
                  [ngClass]="{ 'invalid-input': landPackageForm.get('airfarePerInfant')?.invalid && landPackageForm.get('airfarePerInfant')?.touched }">
                  <app-select-text-input [prefix]="selectedCurrency" formControlName="airfarePerInfant"
                    [placeHolder]="'Enter airfare per infant'"></app-select-text-input>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Total Airfare*</label>
                <div
                  [ngClass]="{ 'invalid-input': landPackageForm.get('totalAirFare')?.invalid && landPackageForm.get('totalAirFare')?.touched }">
                  <app-select-text-input [prefix]="selectedCurrency" formControlName="totalAirFare"></app-select-text-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </ng-container>

      <div class="ion-padding-horizontal">
        <div class="row">
          <div class="col-4">
            <div class="align-items-end py-2">
              <ion-toggle class="cost-toggle-btn" formControlName="showLandPackages" labelPlacement="end">Show Land Package Cost</ion-toggle>
            </div>
          </div>
          <div class="col-4">
            <div class="align-items-end py-2">
              <ion-toggle class="cost-toggle-btn" formControlName="showTotalCost" labelPlacement="end">Show Total Package Cost</ion-toggle>
            </div>
          </div>
        </div>
      </div>

      <div class="ion-padding-horizontal">
        <div class="col-12">
          <div class="input-container">
            <label for="" class="label">Notes</label>
            <div
              [ngClass]="{ 'invalid-input': landPackageForm.get('sectionNote')?.invalid && landPackageForm.get('sectionNote')?.touched }">
              <app-text-formatting-input formControlName="sectionNote"></app-text-formatting-input>
            </div>
          </div>
        </div>
      </div>

    </form>


    <div class="ion-padding-horizontal" *ngIf="!serviceBasedSections.showTourPackage && !serviceBasedSections.showRouteCraft">
      <div class="row">
        <div class="col-6">
          <div class="input-container">
            <label for="" class="label">Total Quote Cost - <span class="text-dark total-cost-value">{{totalItineraryAmount | currency : selectedCurrency}}</span></label>
          </div>
        </div>
      </div>
    </div>






    <ng-container *ngIf="!serviceBasedSections.showRouteCraft && serviceBasedSections.showHotels">
      <ng-container *ngFor="let dest of accommodation?.data">
        <div class="ion-padding-horizontal mt-2" *ngFor="let location of dest.locations">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="sub-title">Accommodation At <span class="blue-text">{{location.locationName}}</span></h6>
            <ion-button fill="clear" size="small" (click)="goToView('accommodation')"><ion-icon
                name="create-outline"></ion-icon> Edit</ion-button>
          </div>
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th>Hotel Name</th>
                  <th class="w-md">Guest</th>
                  <th class="w-md">Cost Per Person</th>
                  <th class="w-md">No of Guest</th>
                  <th class="w-md">Total Cost</th>
                  <th class="w-md">Grand Total</th>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngFor="let hotel of location.hotels">
                  <tr>
                    <td rowspan="3">
                      <div class="p-1">
                        <p class="mb-1 p-0">{{hotel.hotelName}} ({{hotel.hotelType}})</p>
                        <p class="mb-1 p-0">{{hotel.totalRooms}} Rooms ({{hotel.roomCategory || '--'}})</p>
                        <p class="mb-1 p-0">Check-In - {{hotel.checkIn | date}}</p>
                        <p class="mb-1 p-0">Check-Out - {{hotel.checkOut | date}}</p>
                      </div>
                    </td>
                    <td>Adults (12+)</td>
                    <td>{{hotel.costPerAdult || '--'}}</td>
                    <td>{{hotel.noOfAdults || '--'}}</td>
                    <td>{{hotel.costPerAdult * hotel.noOfAdults | currency: selectedCurrency}}</td>
                    <td rowspan="3">{{ hotel.totalCostOfAccommodation | currency: selectedCurrency }}</td>
                  </tr>
                  <tr>
                    <td>Childer (2 - 12)</td>
                    <td>{{hotel.costPerChild || '--'}}</td>
                    <td>{{hotel.noOfChildren || '--'}}</td>
                    <td>{{hotel.costPerChild * hotel.noOfChildren | currency: selectedCurrency}}</td>
                  </tr>
                  <tr>
                    <td>Infants (0 - 2)</td>
                    <td>{{hotel.costPerInfant || '--'}}</td>
                    <td>{{hotel.noOfInfants || '--'}}</td>
                    <td>{{hotel.costPerInfant * hotel.noOfInfants | currency: selectedCurrency}}</td>
                  </tr>

                </ng-container>

              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </ng-container>



    <div class="dashed-line"></div>

    <ng-container *ngIf="!serviceBasedSections.showRouteCraft && serviceBasedSections.showTransportation">
      <!-- Flight data table -->
      <div class="ion-padding-horizontal mt-2" *ngIf="flightsData && flightsData.data?.length">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="sub-title">Flights</h6>
          <ion-button fill="clear" size="small" (click)="goToView('transportation')"><ion-icon
              name="create-outline"></ion-icon> Edit</ion-button>
        </div>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>Travel Details</th>
                <th class="w-md">Guest</th>
                <th class="w-md">Cost Per Person</th>
                <th class="w-md">No of Guest</th>
                <th class="w-md">Total Cost</th>
                <th class="w-md">Grand Total</th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let transport of flightsData.data">
                <tr>
                  <td rowspan="3">
                    <ng-container *ngIf="transport.selectedType === 'Image'">
                      <p>Flight <span class="clickable-text" (click)="openImage(transport.imagePath)">View</span></p>
                    </ng-container>
                    
                    <ng-container *ngIf="transport.selectedType === 'FreeText'">
                      <p class="mb-1 p-0">  {{transport.arrival}} - to - {{transport.departure}}</p>
                      <p class="mb-1 p-0">Arrival - {{transport.arrivalTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                      <p class="mb-1 p-0">Departure - {{transport.departureTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                    </ng-container>
                  </td>
                  <td>Adults (12+)</td>
                  <td>{{transport.costPerAdult || '--'}}</td>
                  <td>{{noOfAdults || '--'}}</td>
                  <td>{{transport.costPerAdult * noOfAdults | currency: selectedCurrency}}</td>
                  <!-- <td rowspan="3">{{ ((transport.costPerAdult * noOfAdults)+(transport.costPerChild * noOfChildren)) |
                    currency: selectedCurrency }}</td> -->
                  <td rowspan="3">{{ transport.totalCost | currency: selectedCurrency }}</td>
                </tr>
                <tr>
                  <td>Children (2 - 12)</td>
                  <td>{{transport.costPerChild || '--'}}</td>
                  <td>{{childrenAboveTwo || '--'}}</td>
                  <td>{{ transport.costPerChild * childrenAboveTwo | currency: selectedCurrency}}</td>
                </tr>
                <tr>
                  <td>Infants (0 - 2)</td>
                  <td>{{transport.costPerInfant || '--'}}</td>
                  <td>{{childrenBelowTwo || '--'}}</td>
                  <td>{{ transport.costPerInfant * childrenBelowTwo | currency: selectedCurrency}}</td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>
      </div>

      <!-- Trains data table -->
      <div class="ion-padding-horizontal mt-2" *ngIf="trainsData && trainsData.data?.length">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="sub-title">Trains</h6>
          <ion-button fill="clear" size="small" (click)="goToView('transportation')"><ion-icon
              name="create-outline"></ion-icon> Edit</ion-button>
        </div>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>Travel Details</th>
                <th class="w-md">Guest</th>
                <th class="w-md">Cost Per Person</th>
                <th class="w-md">No of Guest</th>
                <th class="w-md">Total Cost</th>
                <th class="w-md">Grand Total</th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let transport of trainsData.data">
                <tr>
                  <td rowspan="3">
                     <ng-container *ngIf="transport.selectedType === 'Image'">
                      <p>Train <span class="clickable-text" (click)="openImage(transport.imagePath)">View</span></p>
                    </ng-container>
                    
                    <ng-container *ngIf="transport.selectedType === 'FreeText'">
                      <p class="mb-1 p-0">  {{transport.arrival}} - to - {{transport.departure}}</p>
                      <p class="mb-1 p-0">Arrival - {{transport.arrivalTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                      <p class="mb-1 p-0">Departure - {{transport.departureTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                    </ng-container>
                  </td>
                  <td>Adults (12+)</td>
                  <td>{{transport.costPerAdult || '--'}}</td>
                  <td>{{noOfAdults || '--'}}</td>
                  <td>{{transport.costPerAdult * noOfAdults | currency: selectedCurrency}}</td>
                  <td rowspan="3">{{ transport.totalCost | currency: selectedCurrency }}</td>
                </tr>
                <tr>
                  <td>Children (2 - 12)</td>
                  <td>{{transport.costPerChild || '--'}}</td>
                  <td>{{childrenAboveTwo || '--'}}</td>
                  <td>{{ transport.costPerChild * childrenAboveTwo | currency: selectedCurrency}}</td>
                </tr>
                <tr>
                  <td>Infants (0 - 2)</td>
                  <td>{{transport.costPerInfant || '--'}}</td>
                  <td>{{childrenBelowTwo || '--'}}</td>
                  <td>{{ transport.costPerInfant * childrenBelowTwo | currency: selectedCurrency}}</td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>
      </div>

      <!-- Buses data table -->

      <div class="ion-padding-horizontal mt-2" *ngIf="busesData && busesData.data?.length">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="sub-title">Buses</h6>
          <ion-button fill="clear" size="small" (click)="goToView('transportation')"><ion-icon
              name="create-outline"></ion-icon> Edit</ion-button>
        </div>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>Travel Details</th>
                <th class="w-md">Guest</th>
                <th class="w-md">Cost Per Person</th>
                <th class="w-md">No of Guest</th>
                <th class="w-md">Total Cost</th>
                <th class="w-md">Grand Total</th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let transport of busesData.data">
                <tr>
                  <td rowspan="3">
                     <ng-container *ngIf="transport.selectedType === 'Image'">
                      <p>Bus <span class="clickable-text" (click)="openImage(transport.imagePath)">View</span></p>
                    </ng-container>
                    
                    <ng-container *ngIf="transport.selectedType === 'FreeText'">
                      <p class="mb-1 p-0">  {{transport.arrival}} - to - {{transport.departure}}</p>
                      <p class="mb-1 p-0">Arrival - {{transport.arrivalTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                      <p class="mb-1 p-0">Departure - {{transport.departureTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                    </ng-container>
                  </td>
                  <td>Adults (12+)</td>
                  <td>{{transport.costPerAdult || '--'}}</td>
                  <td>{{noOfAdults || '--'}}</td>
                  <td>{{transport.costPerAdult * noOfAdults | currency: selectedCurrency}}</td>
                  <td rowspan="3">{{ transport.totalCost | currency: selectedCurrency }}</td>
                </tr>
                <tr>
                  <td>Children (2 - 12)</td>
                  <td>{{transport.costPerChild || '--'}}</td>
                  <td>{{childrenAboveTwo || '--'}}</td>
                  <td>{{ transport.costPerChild * childrenAboveTwo | currency: selectedCurrency}}</td>
                </tr>
                <tr>
                  <td>Infants (0 - 2)</td>
                  <td>{{transport.costPerInfant || '--'}}</td>
                  <td>{{childrenBelowTwo || '--'}}</td>
                  <td>{{ transport.costPerInfant * childrenBelowTwo | currency: selectedCurrency}}</td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <ng-container  *ngIf="!serviceBasedSections.showRouteCraft && (serviceBasedSections.showTransportation || serviceBasedSections.showTransfers)">
      <!-- Cars data  table -->
      <div class="ion-padding-horizontal mt-2" *ngIf="carsData && carsData.data?.length">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="sub-title">Cars</h6>
          <ion-button fill="clear" size="small" (click)="goToView('transportation')"><ion-icon
              name="create-outline"></ion-icon> Edit</ion-button>
        </div>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>Travel Details</th>
                <th class="w-md">Guest</th>
                <th class="w-md">Cost Per Person</th>
                <th class="w-md">No of Guest</th>
                <th class="w-md">Total Cost</th>
                <th class="w-md">Grand Total</th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let transport of carsData.data">
                <tr>
                  <td rowspan="3">
                     <ng-container *ngIf="transport.selectedType === 'Image'">
                      <p>Car <span class="clickable-text" (click)="openImage(transport.imagePath)">View</span></p>
                    </ng-container>
                    
                    <ng-container *ngIf="transport.selectedType === 'FreeText'">
                      <p class="mb-1 p-0">  {{transport.arrival}} - to - {{transport.departure}}</p>
                    </ng-container>
                  </td>
                  <td>Adults (12+)</td>
                  <td>{{transport.costPerAdult || '--'}}</td>
                  <td>{{noOfAdults || '--'}}</td>
                  <td>{{transport.costPerAdult * noOfAdults | currency: selectedCurrency}}</td>
                  <td rowspan="3">{{ transport.totalCost | currency: selectedCurrency }}</td>
                </tr>
                <tr>
                  <td>Children (2 - 12)</td>
                  <td>{{transport.costPerChild || '--'}}</td>
                  <td>{{childrenAboveTwo || '--'}}</td>
                  <td>{{ transport.costPerChild * childrenAboveTwo | currency: selectedCurrency}}</td>
                </tr>
                <tr>
                  <td>Infants (0 - 2)</td>
                  <td>{{transport.costPerInfant || '--'}}</td>
                  <td>{{childrenBelowTwo || '--'}}</td>
                  <td>{{ transport.costPerInfant * childrenBelowTwo | currency: selectedCurrency}}</td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!serviceBasedSections.showRouteCraft && serviceBasedSections.showTransportation">
      <!-- Ferry data table -->
      <div class="ion-padding-horizontal mt-2" *ngIf="ferryData && ferryData.data?.length">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="sub-title">Ferry</h6>
          <ion-button fill="clear" size="small" (click)="goToView('transportation')"><ion-icon
              name="create-outline"></ion-icon> Edit</ion-button>
        </div>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>Travel Details</th>
                <th class="w-md">Guest</th>
                <th class="w-md">Cost Per Person</th>
                <th class="w-md">No of Guest</th>
                <th class="w-md">Total Cost</th>
                <th class="w-md">Grand Total</th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let transport of ferryData.data">
                <tr>
                  <td rowspan="3">
                     <ng-container *ngIf="transport.selectedType === 'Image'">
                      <p>Ferry <span class="clickable-text" (click)="openImage(transport.imagePath)">View</span></p>
                    </ng-container>
                    
                    <ng-container *ngIf="transport.selectedType === 'FreeText'">
                      <p class="mb-1 p-0">  {{transport.arrival}} - to - {{transport.departure}}</p>
                      <p class="mb-1 p-0">Arrival - {{transport.arrivalTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                      <p class="mb-1 p-0">Departure - {{transport.departureTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                    </ng-container>
                  </td>
                  <td>Adults (12+)</td>
                  <td>{{transport.costPerAdult || '--'}}</td>
                  <td>{{noOfAdults || '--'}}</td>
                  <td>{{transport.costPerAdult * noOfAdults | currency: selectedCurrency}}</td>
                  <!-- <td rowspan="3">{{ ((transport.costPerAdult * noOfAdults)+(transport.costPerChild * noOfChildren)) |
                    currency: selectedCurrency }}</td> -->
                  <td rowspan="3">{{ transport.totalCost | currency: selectedCurrency }}</td>
                </tr>
                <tr>
                  <td>Children (2 - 12)</td>
                  <td>{{transport.costPerChild || '--'}}</td>
                  <td>{{childrenAboveTwo || '--'}}</td>
                  <td>{{ transport.costPerChild * childrenAboveTwo | currency: selectedCurrency}}</td>
                </tr>
                <tr>
                  <td>Infants (0 - 2)</td>
                  <td>{{transport.costPerInfant || '--'}}</td>
                  <td>{{childrenBelowTwo || '--'}}</td>
                  <td>{{ transport.costPerInfant * childrenBelowTwo | currency: selectedCurrency}}</td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>
      </div>

      <!-- Cruise data table -->
      <div class="ion-padding-horizontal mt-2" *ngIf="cruiseData && cruiseData.data?.length">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="sub-title">Cruise</h6>
          <ion-button fill="clear" size="small" (click)="goToView('transportation')"><ion-icon
              name="create-outline"></ion-icon> Edit</ion-button>
        </div>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>Travel Details</th>
                <th class="w-md">Guest</th>
                <th class="w-md">Cost Per Person</th>
                <th class="w-md">No of Guest</th>
                <th class="w-md">Total Cost</th>
                <th class="w-md">Grand Total</th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let transport of cruiseData.data">
                <tr>
                  <td rowspan="3">
                     <ng-container *ngIf="transport.selectedType === 'Image'">
                      <p>Cruise <span class="clickable-text" (click)="openImage(transport.imagePath)">View</span></p>
                    </ng-container>
                    
                    <ng-container *ngIf="transport.selectedType === 'FreeText'">
                      <p class="mb-1 p-0">  {{transport.arrival}} - to - {{transport.departure}}</p>
                      <p class="mb-1 p-0">Arrival - {{transport.arrivalTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                      <p class="mb-1 p-0">Departure - {{transport.departureTime | date : 'MMM d, yyyy - h:mm a'}}</p>
                    </ng-container>
                  </td>
                  <td>Adults (12+)</td>
                  <td>{{transport.costPerAdult || '--'}}</td>
                  <td>{{noOfAdults || '--'}}</td>
                  <td>{{transport.costPerAdult * noOfAdults | currency: selectedCurrency}}</td>
                  <!-- <td rowspan="3">{{ ((transport.costPerAdult * noOfAdults)+(transport.costPerChild * noOfChildren)) |
                    currency: selectedCurrency }}</td> -->
                  <td rowspan="3">{{ transport.totalCost | currency: selectedCurrency }}</td>
                </tr>
                <tr>
                  <td>Children (2 - 12)</td>
                  <td>{{transport.costPerChild || '--'}}</td>
                  <td>{{childrenAboveTwo || '--'}}</td>
                  <td>{{ transport.costPerChild * childrenAboveTwo | currency: selectedCurrency}}</td>
                </tr>
                <tr>
                  <td>Infants (0 - 2)</td>
                  <td>{{transport.costPerInfant || '--'}}</td>
                  <td>{{childrenBelowTwo || '--'}}</td>
                  <td>{{ transport.costPerInfant * childrenBelowTwo | currency: selectedCurrency}}</td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>
      </div>
    </ng-container>



  </div>

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>